import { Stack, Typography } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { snakeToCamelLabel } from 'core/utils';
import { Direction } from 'theme/enums';

interface ICriteriaItem {
  fieldName: string;
  operator: string;
  value: string;
  uomName: string;
}

interface ICriteriaCellProps extends ICellRendererParams {
  criteriaFieldName: 'partFieldName' | 'corporatePartFieldName';
}

export const CriteriaCell = ({ value, criteriaFieldName }: ICriteriaCellProps) => {
  if (!value) {
    return null;
  }

  const criteria = value.map((item) => ({
    fieldName: item[criteriaFieldName],
    operator: item.operator,
    value: item.value,
    uomName: item.uomName,
  }));

  return (
    <>
      {criteria.map((item: ICriteriaItem, index: number) => {
        const displayName =
          criteriaFieldName === 'corporatePartFieldName'
            ? t(snakeToCamelLabel(item.fieldName))
            : item.fieldName;

        return (
          <Stack key={index} direction={Direction.ROW} gap={1}>
            <Typography fontWeight="bold">{displayName}</Typography>
            <Typography>{item.operator}</Typography>
            <Typography fontWeight="bold">
              {item.value} {item.uomName}
            </Typography>
          </Stack>
        );
      })}
    </>
  );
};
